"use client";

import { useMemo } from "react";
import { useCardDataContext } from "@/contexts/CardDataContext";
import {
  setRuntimeCardData,
  setRuntimeAAData,
} from "@/lib/games/onePiece/getCardDataLocal";

/**
 * Component that initializes the card data manager with data from context
 * Must be used inside CardDataProvider
 */
export function CardDataInitializer({
  children,
}: {
  children: React.ReactNode;
}) {
  const { cardData, aaData, isLoading } = useCardDataContext();

  console.log(
    "[TEST] CardDataInitializer render - isLoading:",
    isLoading,
    "cardData keys:",
    Object.keys(cardData).length,
    "aaData keys:",
    Object.keys(aaData).length,
  );

  // Set runtime data using useMemo to ensure it runs early and only once per cardData change
  // This ensures card data is available before any child component tries to access it
  const dataInitialized = useMemo(() => {
    if (!isLoading && Object.keys(cardData).length > 0) {
      console.log(
        "[TEST] Setting runtime card data in useMemo with",
        Object.keys(cardData).length,
        "cards",
      );
      console.log(
        "[TEST] EB05 cards in data:",
        Object.keys(cardData).filter((id) => id.startsWith("EB05")).length,
      );
      setRuntimeCardData(cardData);

      if (Object.keys(aaData).length > 0) {
        console.log(
          "[TEST] Setting runtime AA data with",
          Object.keys(aaData).length,
          "entries",
        );
        setRuntimeAAData(aaData);
      }

      return true;
    }
    return false;
  }, [cardData, aaData, isLoading]);

  // Show loading state while card data is being fetched
  if (isLoading || !dataInitialized) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
          <p>Loading card data...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
